<template>
  <!--================ start footer Area  =================-->
  <footer class="footer-area section_gap">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div v-if="textoRodape != ''" class="single-footer-widget">
            <router-link to="/" class="navbar-brand logo_h"><img :src="$imagens + 'logo-footer.png'"
                alt=""></router-link><br><br>
            <p v-html="textoRodape[0].itiResumo1" class="txt-branco"></p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h6 class="footer_title">Menu</h6>
            <div class="row">
              <div class="col-12">
                <ul class="list_style">
                  <li><router-link to="/">Home</router-link></li>
                  <li><router-link to="/sobre">Sobre a Empresa</router-link></li>
                  <li><router-link to="/blog">Notícias</router-link></li>
                  <li><router-link to="/contato">Contato</router-link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h6 class="footer_title">Serviços</h6>
            <div class="row">
              <div class="col-12">
                <ul class="list_style">
                  <li v-for="menu in listaServicos" :key="menu.itiId"><router-link
                      :to="'/ServicosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)"> {{
                        menu.itiNome }} </router-link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget instafeed">
            <h6 class="footer_title">Informações Gerais</h6>
            <div class="row">
              <div class="col-12">
                <ul class="list_style">
                  <li v-for="lgpd in informacoes" :key="lgpd.itiId">
                    <router-link
                      :to="'/informacoes/' + lgpd.itiId + '/' + lgpd.itiNome.replaceAll(' ', '-').replaceAll(',', '')">{{
                      lgpd.itiNome }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="border_line"></div>
      <div class="row footer-bottom d-flex justify-content-between align-items-center">
        <p class="col-6 col-sm-6 footer-text m-0">
          <a href="https://avancedigital.com.br" target="_blank">Avance Digital</a>
        </p>
        <div v-if="redesSociais != ''" class="col-6 col-sm-6 footer-social">
          <a :href="redesSociais[0].itiNome" target="_blank"><i class="fa fa-facebook"></i></a>
          <a :href="redesSociais[0].itiReferencia" target="_blank"><i class="fa fa-instagram"></i></a>
          <a :href="redesSociais[0].itiCampoExtra2" target="_blank"><i class="fa fa-linkedin"></i></a>
        </div>
      </div>
    </div>
  </footer>
  <!--================ End footer Area  =================-->

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },
  
  data: () => ({
    textoRodape: [],
    redesSociais: [],
    informacoes: [],
    listaServicos: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },

  created() {
    // texto
    axios.get('/Process/InsInstitucional/institucional/10/dadosrodape/0/x')
      .then(response => {
        this.textoRodape = response.data;
        //console.log('textoRodape')
        //console.log(this.textoRodape)
      })
      .catch(error => {
        console.error(error);
      });

    // redes sociais 
    axios.get('/Process/InsInstitucional/institucional/55/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('redesSociais')
        //console.log(this.redesSociais)
      })
      .catch(error => {
        console.error(error);
      });

    // serviços
    axios.get('/Process/InsInstitucional/institucional/46/listadeservicos/0/x')
      .then(response => {
        this.listaServicos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaServicos')
        //console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // informações gerais
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('informacoes')
        //console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>